function carousel() {
  const track = document.querySelector('#post-carousel .carousel-track');
  const slides = document.querySelectorAll('#post-carousel .carousel-slide');
  const prevBtn = document.querySelector('#post-carousel .prev');
  const nextBtn = document.querySelector('#post-carousel .next');

  if (!track || !slides.length || !prevBtn || !nextBtn) return; // Ensure elements exist

  let index = 0;
  let slideCount = slides.length;

  function updateCarousel() {
    const slideWidth = slides[0].offsetWidth;
    track.style.transform = `translateX(-${index * slideWidth}px)`;
  }

  function nextSlide() {
    index = (index + 1) % slideCount;
    updateCarousel();
  }

  function prevSlide() {
    index = (index - 1 + slideCount) % slideCount;
    updateCarousel();
  }

  nextBtn.addEventListener('click', nextSlide);
  prevBtn.addEventListener('click', prevSlide);

  const intervalTime = 5000; // 5 seconds

  // Autoplay
  let autoPlay = setInterval(nextSlide, intervalTime);

  // Pause on hover
  document.querySelector('#post-carousel').addEventListener('mouseenter', () => clearInterval(autoPlay));
  document.querySelector('#post-carousel').addEventListener('mouseleave', () => {
    autoPlay = setInterval(nextSlide, intervalTime);
  });

  // Swipe support (mobile)
  let startX = 0;
  track.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener('touchend', e => {
    const endX = e.changedTouches[0].clientX;
    if (startX - endX > 50) nextSlide();
    else if (endX - startX > 50) prevSlide();
  });

  window.addEventListener('resize', updateCarousel);
  window.addEventListener('load', updateCarousel);
}
